import { render, staticRenderFns } from "./Acesso.vue?vue&type=template&id=389f8778"
import script from "./Acesso.vue?vue&type=script&lang=js"
export * from "./Acesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports